import { InferGetStaticPropsType } from 'next'

/* blocks */
import Layout from '@/cmp/templates/Layout/Layout'
import TalentMarketplace from '@/templates/TalentMarketplace/TalentMarketplace'

/* utils */
import {
  pageQuery,
  PageResponse
} from '@/utils/queries/product/talent-marketplace'
import { getStrapiGraphqlData } from '@/utils/api/wrapper'
import {
  INSTANT_REVALIDATION,
  TEN_MINS_REVALIDATION
} from '@/utils/constants/revalidation'
import { constructMetadataFromStrapiData } from '@/utils/functions/strapi'
import { capture404PageError } from '@/utils/functions/elk-server'
import { constructFaqJsonSchema } from '@/utils/functions/jsonSchema'

function TalentMarketplacePage({
  data
}: InferGetStaticPropsType<typeof getStaticProps>): JSX.Element {
  return (
    <Layout
      title={data.seo.title}
      meta={constructMetadataFromStrapiData(data.seo)}
      jsonSchema={[constructFaqJsonSchema(data.faqs)]}
      canonical="/product/talent-marketplace/"
    >
      <TalentMarketplace data={data} />
    </Layout>
  )
}

export const getStaticProps = async () => {
  const result = await getStrapiGraphqlData<PageResponse>(
    pageQuery.loc?.source.body
  )

  if (!result || !result.page.data) {
    capture404PageError(`/product/talent-marketplace/`)
    return { notFound: true, revalidate: INSTANT_REVALIDATION }
  }

  return {
    props: {
      data: result.page.data.attributes,
      services: result.pageData.data.map(i => i.attributes)
    },
    revalidate: TEN_MINS_REVALIDATION
  }
}

export default TalentMarketplacePage
